<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Connection Type Setup</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item active">Connection Type Setup</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12" v-if="isCreate">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Add New Connection</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label" for="name">Name</label>
                      <div class="input-group">
                        <span class="input-group-text" id="inputGroupPrepend">@</span>
                        <input v-model="name" class="form-control" id="color" type="text" placeholder="Full Name"
                          aria-describedby="inputGroupPrepend" required />
                      </div>
                    </div>

                    <!-- <div class="col-md-3">
                      <label class="form-label" for="status"
                        >Active Status</label
                      >
                      <div class="media-body switch-md">
                        <label class="switch">
                          <input
                            v-model="status"
                            type="checkbox"
                            checked="true"
                          /><span class="switch-state"></span>
                        </label>
                      </div>
                    </div> -->
                  </div>
                  <button class="btn btn-primary" type="submit" @click="addNew">
                    Add
                  </button>
                  <!-- </form> -->
                </div>
              </div>
            </div>
            <!-- Update -->
            <!-- Create New -->
            <div class="col-sm-12 col-lg-12" v-if="!isCreate">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>Update Connection</h5>
                </div>
                <div class="card-body">
                  <!-- <form> -->
                  <div class="row g-3">
                    <div class="col-md-3">
                      <label class="form-label" for="name">Name</label>
                      <div class="input-group">
                        <span class="input-group-text" id="inputGroupPrepend">@</span>
                        <input v-model="update.title" class="form-control" id="color" type="text" placeholder="Full Name"
                          aria-describedby="inputGroupPrepend" required />
                      </div>
                    </div>

                    <!-- <div class="col-md-3">
                      <label class="form-label" for="status"
                        >Active Status</label
                      >
                      <div
                        class="media-body switch-md"
                        v-if="update.active_status"
                      >
                        <label class="switch">
                          <input
                            v-model="update.active_status"
                            type="checkbox"
                            checked="true"
                          /><span class="switch-state"></span>
                        </label>
                      </div>
                      <div
                        class="media-body switch-md"
                        v-if="!update.active_status"
                      >
                        <label class="switch">
                          <input
                            v-model="update.active_status"
                            type="checkbox"
                            checked="false"
                          /><span class="switch-state"></span>
                        </label>
                      </div>
                    </div> -->
                  </div>
                  <button class="btn btn-primary" type="submit" @click="updateTypeSubmit">
                    Update
                  </button>
                  <button class="btn btn-danger" type="submit" @click="cancelUpdate">
                    Cancel
                  </button>
                  <!-- </form> -->
                </div>
              </div>
            </div>
            <!-- Data table -->
            <div class="col-sm-12 col-lg-12">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                  <span>Connection Type Status</span>
                </div>
                <div class="card-body">
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="connectionTypeTBL">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Name</th>
                          <th>Active Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr align="center" v-for="(item, index) in connectionTypes" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.title }}</td>
                          <td>
                            <div class="media-body switch-sm" v-if="item.active_status === 1"
                              @click.prevent="changeStatus(item.id)">
                              <label class="switch">
                                <input type="checkbox" checked /><span class="switch-state"></span>
                              </label>
                            </div>
                            <div class="media-body switch-sm" v-if="item.active_status === 0"
                              @click.prevent="changeStatus(item.id)">
                              <label class="switch">
                                <input type="checkbox" /><span class="switch-state"></span>
                              </label>
                            </div>
                          </td>
                          <td>
                            <button class="btn btn-danger btn-xs" type="button"
                              data-original-title="btn btn-danger btn-xs" title="" @click.prevent="deleteType(item.id)">
                              Delete
                            </button>
                            <button v-if="item.active_status === 1" class="btn btn-primary btn-xs" type="button"
                              data-original-title="btn btn-danger btn-xs" title="" @click.prevent="updateType(item)">
                              Edit
                            </button>
                          </td>
                        </tr>
                        <!-- <tr align="center">
                                                        <td>1</td>
                                                        <td>test</td>
                                                        <td>
                                                            <div class="media-body switch-sm">
                                                                <label class="switch">
                                                                    <input type="checkbox" checked><span class="switch-state"></span>
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <button class="btn btn-danger btn-xs" type="button" data-original-title="btn btn-danger btn-xs" title="">Delete</button>
                                                            <button class="btn btn-primary btn-xs" type="button" data-original-title="btn btn-danger btn-xs" title="">Edit</button>
                                                        </td>
                                                    </tr>
                                                    <tr align="center">
                                                        <td>1</td>
                                                        <td>test</td>
                                                        <td>
                                                            <div class="media-body switch-sm">
                                                                <label class="switch">
                                                                    <input type="checkbox" checked><span class="switch-state"></span>
                                                                </label>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <button class="btn btn-danger btn-xs" type="button" data-original-title="btn btn-danger btn-xs" title="">Delete</button>
                                                            <button class="btn btn-primary btn-xs" type="button" data-original-title="btn btn-danger btn-xs" title="">Edit</button>
                                                        </td>
                                                    </tr> -->
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
      </div>
    </div>
  </div>
</template>

<script>
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import $ from 'jquery';
import ConnectionTypeAPI from '../../../services/connectionType.API';
export default {
  name: 'ConnectionTypes',
  components: {},
  data() {
    return {
      name: '',
      status: '',
      connectionTypes: [],
      isCreate: true,
      update: {
        id: '',
        title: '',
        // active_status: '',
      },
    };
  },
  methods: {

    addNew() {
      //   console.log(this.name, this.status);
      if (this.name == '') {
        this.$moshaToast('Please enter connection type name', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      } else {
        let data = {
          title: this.name,
          status: this.status,
        };
        ConnectionTypeAPI.createConnectionType(data)
          .then(response => {
            this.$moshaToast(response.data.message, {
              type: 'success',
              position: 'top-right',
              showIcon: true,
            });
            // get all connection type
            ConnectionTypeAPI.typeList().then(response => {
              this.connectionTypes = response.data.data;
            });
            this.name = '';
            this.status = '';
          })
          .catch(error => {
            console.log(error.response.data.success);
            if (error.response.data.success === false) {
              this.$moshaToast(error.response.data.message, {
                type: 'danger',
                position: 'top-right',
                showIcon: true,
              });
            }
          });
      }
    },

    // delete
    deleteType(id) {
      if (id) {

        this.$swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.isConfirmed) {

            ConnectionTypeAPI.deleteConnectionType(id).then(response => {
              this.$moshaToast(response.data.message, {
                type: 'success',
                position: 'top-right',
                showIcon: true,
              });
              // get all connection type
              ConnectionTypeAPI.typeList().then(response => {
                this.connectionTypes = response.data.data;
              });
            });
          }
        })

      } else {
        this.$moshaToast('Please select connection type', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      }
    },

    // change status
    changeStatus(id) {
      if (id) {
        ConnectionTypeAPI.changeStatus(id).then(response => {
          this.$moshaToast(response.data.message, {
            type: 'success',
            position: 'top-right',
            showIcon: true,
          });
          // get all connection type
          ConnectionTypeAPI.typeList().then(response => {
            this.connectionTypes = response.data.data;
          });
        });
      } else {
        this.$moshaToast('Please select connection type', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      }
    },

    // update
    updateType(item) {
      this.isCreate = false;
      //   this.name = item.title;
      //   this.status = item.status === 1 ? true : false;
      this.id = item.id;
      console.log(this.update);
      this.update.id = item.id;
      this.update.title = item.title;
      // this.update.active_status = item.active_status === 1 ? true : false;
    },

    // cancelUpdate
    cancelUpdate() {
      this.isCreate = true;
      this.update.id = '';
      this.update.title = '';
      // this.update.active_status = '';
    },

    // update submit
    updateTypeSubmit() {
      if (this.update.title == '') {
        this.$moshaToast('Please enter connection type name', {
          type: 'danger',
          position: 'top-right',
          showIcon: true,
        });
      }
      //  else if (this.update.active_status == '') {
      //   this.$moshaToast('Please select status', {
      //     type: 'danger',
      //     position: 'top-right',
      //     showIcon: true,
      //   });
      // } 
      else {
        console.log(this.update);
        let data = {
          id: this.update.id,
          title: this.update.title,
          // active_status: this.update.active_status === true ? 1 : 0,
        };
        ConnectionTypeAPI.updateConnectionType(data)
          .then(response => {
            this.$moshaToast(response.data.message, {
              type: 'success',
              position: 'top-right',
              showIcon: true,
            });
            // get all connection type
            ConnectionTypeAPI.typeList().then(response => {
              this.connectionTypes = response.data.data;
            });
            this.isCreate = true;
            this.update.id = '';
            this.update.title = '';
            // this.update.active_status = '';
          })
          .catch(error => {
            console.log(error.response.data.success);
            if (error.response.data.success === false) {
              this.$moshaToast(error.response.data.message, {
                type: 'danger',
                position: 'top-right',
                showIcon: true,
              });
            }
          });
      }
    },
  },
  mounted() {
    //   list
    ConnectionTypeAPI.typeList().then(response => {
      this.connectionTypes = response.data.data;
      setTimeout(() => {
        $('#connectionTypeTBL').DataTable({
          lengthMenu: [
            [10, 25, 50, -1],
            [10, 25, 50, 'All'],
          ],
          pageLength: 10,
          info: false,
          targets: 'no-sort',
          bSort: false,
          order: [],
          bFilter: true,
          bInfo: false,
          //   bLengthChange: false,
          bDestroy: true,
        });
      });
    });
  },
};
</script>

<style scoped>
.btn {
  margin: 5px;
}

span.switch-state:before {
  background: #000 !important;
  margin-bottom: -2px !important;
}

span.switch-state {
  border: 2px solid #000 !important;
}
</style>